import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import IconNotFound from '../../assets/icons/IconNotFound';

class FilterCustomerService extends Component {
    handleSelectCustomerService = data => {
        this.setState({ showSelectCusomerService: false })
        this.props.handleSelectCustomerService(data);
    }

    handleDropdown = e => {
        if (this.dropdownRef && this.inputRef && !this.dropdownRef.current.contains(e.target) && !this.inputRef.current.contains(e.target)) {
            this.setState({
                showSelectCusomerService: false
            })
        }
    }

    render() {
        return (
            <div className="text-gray-600 py-3">
                <div className="flex rounded-full bg-white border border-gray-300 px-2">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                    </div>
                    <input type="text" id="tslcustomerservicename" placeholder="Ketik Nama CS" className="outline-none text-sm w-full" value={this.props.data.value} onChange={this.props.handleChangeCustomerService} />
                    <div className="ml-1">
                        <FontAwesomeIcon icon={faTimesCircle} className="text-gray-400 cursor-pointer select-default" id="btnclearcustomerservice" onClick={this.props.handleClear} />
                    </div>
                </div>
                <div className="max-h-60 overflow-y-auto">
                    {
                        this.props.data.data.length > 0 ?
                            this.props.data.data.map((customerService, idx) =>
                                <div className="pt-3 pl-3 pr-3 hover:bg-blue-100 cursor-default select-default" key={idx}>
                                    <p className="pb-3 border-b-2 border-gray text-sm truncate" id="btnselectcustomerservice" onClick={() => this.handleSelectCustomerService(customerService)}>{customerService.name}</p>
                                </div>
                            )
                            :
                            <div className="pt-3 pl-3 pr-3 text-center flex flex-col items-center">
                                <IconNotFound />
                                <p className="pb-3 text-sm mt-3">CS Tidak Ditemukan!</p>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

export default FilterCustomerService;